class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");

    if (this.mainDetailsToggle) {
      this.content =
        this.mainDetailsToggle.querySelector("summary").nextElementSibling;

      this.mainDetailsToggle.addEventListener(
        "focusout",
        this.onFocusOut.bind(this)
      );
      this.mainDetailsToggle.addEventListener(
        "toggle",
        this.onToggle.bind(this)
      );
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.removeAttribute("open");
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
    }
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.querySelectorAll(
      "header-menu .header__submenu>li details summary"
    ).forEach((d) =>
      d.addEventListener("click", (e) => {
        const detail_id = e.target.parentNode.id;
        if (!detail_id) return;
        this.querySelectorAll(
          `header-menu .header__submenu>li details:not(#${e.target.parentNode.id})`
        ).forEach((dt) => {
          dt.removeAttribute("open");
        });
      })
    );
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);
